import React from 'react';
import TextStyle from '@rezdy/components/TextStyle';
import { Title } from './Styled';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';
import { ResendCode } from '../ResendCode';
import { ContactSupport } from '../ContactSupport';

export class VerifyEmailExpiredLink extends React.PureComponent<{ username: string } & WithTranslation> {
    render(): React.ReactNode {
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <Title>{i18n.t('Your verification link has expired')}</Title>
                <Trans i18nKey="verifyEmail.body">
                    <TextStyle as="p">
                        We&#39;ve just sent another verification email to <b>{this.props.username}</b> to verify your
                        account.
                        <br />
                        Please verify your account to continue account setup.
                    </TextStyle>
                    <TextStyle as="p">
                        If you haven&#39;t received the verification email after a few minutes, you may need to check
                        your spam folder.
                        <br />
                        <ResendCode {...this.props} />
                    </TextStyle>

                    <ContactSupport />
                </Trans>
            </React.Fragment>
        );
    }
}

export default withTranslation()(VerifyEmailExpiredLink);
